import React from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';

export type ErrorMessageBoxProps = {
    children:React.ReactNode;
    title:string;
    message:string;
    showControls:boolean;
};

export const ErrorMessageBox = ({children, title=null, message='', showControls=true}:ErrorMessageBoxProps)=>{
    const { school } = useParams();
    const navigate = useNavigate();

    return (
        <div className="section">
            <div className="inner">
                <div className="alert_box alignC">
                    { null!==title && <div className="title">{title}</div> }
                    <p>{message}</p>
                    { showControls &&
                        <div className="bbs_btn">
                            <Link to={`/${school}`} className="btn _sm _red">홈</Link>
                            &nbsp;
                            <button className="btn _sm _blue" onClick={()=>navigate(-1)}>이전 페이지</button>
                            &nbsp;
                            {children}
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}//